import { render, staticRenderFns } from "./ResourceForms.vue?vue&type=template&id=4be56ad3&scoped=true"
import script from "./ResourceForms.vue?vue&type=script&lang=ts"
export * from "./ResourceForms.vue?vue&type=script&lang=ts"
import style0 from "./ResourceForms.vue?vue&type=style&index=0&id=4be56ad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be56ad3",
  null
  
)

export default component.exports